import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-angle-left",
  "use": "arrow-angle-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-angle-left\"><path d=\"M10 5.22c.195-.195.377-.622 0-1-.378-.378-.805-.195-1 0l-4 4 4 4c.195.195.602.398 1 0s.195-.805 0-1l-3-3 3-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol